/* @flow */
import * as React from 'react';
import { Redirect, Route } from 'react-router-dom';
import AppliedRoute from './AppliedRoute';

type Props = {
  component: React.ComponentType<any>,
  props: Object,
};

export default function AuthenticatedRoute<C: React.ComponentType<Props>>({
  component: Component,
  props: cProps,
  ...rest
}: Props): React.Element<C> {
  return (
    <Route
      {...rest}
      render={(props) => {
        if (cProps.auth.isAuthorized !== false) {
          return <AppliedRoute {...props} props={cProps} component={Component} />;
        }
        return <Redirect to="/login" />;
      }}
    />
  );
}
